import { render, staticRenderFns } from "./lottery.vue?vue&type=template&id=a8a90b9a&scoped=true&"
import script from "./lottery.vue?vue&type=script&lang=ts&"
export * from "./lottery.vue?vue&type=script&lang=ts&"
import style0 from "./lottery.vue?vue&type=style&index=0&id=a8a90b9a&prod&lang=scss&scoped=true&"
import style1 from "./lottery.vue?vue&type=style&index=1&id=a8a90b9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a90b9a",
  null
  
)

export default component.exports